import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';

import "./RecordTime.css";

function RecordTime() {
  const [isRunning, setIsRunning] = useState(false);
  const [isUseful, setIsUseful] = useState(true);
  const [usefulTime, setUsefulTime] = useState(0);
  const [unusefulTime, setUnusefulTime] = useState(0);
  const [intervalId, setIntervalId] = useState(null);
  const [history, setHistory] = useState([]);
  const [customLabel, setCustomLabel] = useState("Session");
  const [presetLabel, setPresetLabel] = useState("");
  const [filterLabel, setFilterLabel] = useState("");

  // Dynamic labels list
  const [labels, setLabels] = useState([
    "Work",
    "Exercise",
    "Leisure",
    "Study",
    "Break",
  ]);

  useEffect(() => {
    if (isRunning) {
      const id = setInterval(() => {
        if (isUseful) {
          setUsefulTime((prev) => prev + 1);
        } else {
          setUnusefulTime((prev) => prev + 1);
        }
      }, 1000);
      setIntervalId(id);
    } else {
      clearInterval(intervalId);
    }
    return () => clearInterval(intervalId);
  }, [isRunning, isUseful]);

  const handleStartPause = () => {
    setIsRunning(!isRunning);
  };

  const handleStop = () => {
    setIsRunning(false);
    const totalTime = usefulTime + unusefulTime;
    if (totalTime > 0) {
      const finalLabel = presetLabel || customLabel;
      setHistory((prev) => [
        ...prev,
        {
          label: finalLabel,
          useful: usefulTime,
          unuseful: unusefulTime,
          total: totalTime,
          date: new Date().toLocaleString(),
        },
      ]);
    }
    setUsefulTime(0);
    setUnusefulTime(0);
  };

  const toggleMode = () => {
    setIsUseful(!isUseful);
  };

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}m ${secs}s`;
  };

    const totalTime = usefulTime + unusefulTime;
  const usefulPercent = totalTime ? (usefulTime / totalTime) * 100 : 0;
  const unusefulPercent = totalTime ? (unusefulTime / totalTime) * 100 : 0;

  const exportCSV = () => {
    if (history.length === 0) return;

    const header = ["Date", "Label", "Useful Time (s)", "Unuseful Time (s)", "Total Time (s)"];
    const rows = history.map((session) => [
      session.date,
      session.label,
      session.useful,
      session.unuseful,
      session.total,
    ]);

    const csvContent =
      [header, ...rows].map((row) => row.join(",")).join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "session_history.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const getLabelClass = (label) => {
    switch (label.toLowerCase()) {
      case "work":
        return "tag work";
      case "exercise":
        return "tag exercise";
      case "leisure":
        return "tag leisure";
      case "study":
        return "tag study";
      case "break":
        return "tag break";
      default:
        return "tag custom";
    }
  };

  const filteredHistory = filterLabel
    ? history.filter((session) => session.label.toLowerCase() === filterLabel.toLowerCase())
    : history;

  // Add custom label to list
  const handleAddCustom = () => {
    if (customLabel.trim() && !labels.includes(customLabel)) {
      setLabels((prev) => [...prev, customLabel]);
    }
  };

  // Summary calculations
  const totalUsefulAll = history.reduce((sum, s) => sum + s.useful, 0);
  const totalUnusefulAll = history.reduce((sum, s) => sum + s.unuseful, 0);
  const grandTotalAll = history.reduce((sum, s) => sum + s.total, 0);
  const avgUseful = history.length ? totalUsefulAll / history.length : 0;
  const avgUnuseful = history.length ? totalUnusefulAll / history.length : 0;
  const avgTotal = history.length ? grandTotalAll / history.length : 0;

  return (
    <div className="app">
      <h1>Time Tracker</h1>

      {/* Label input and preset dropdown */}
      <div className="label-input">
        <label>
          Custom Label:{" "}
          <input
            type="text"
            value={customLabel}
            onChange={(e) => setCustomLabel(e.target.value)}
            placeholder="Enter custom name"
          />
        </label>
        <div className="buttons">
        <button onClick={handleAddCustom}>Add Custom</button></div>
        <label>
          Cagetory:{" "}
          <select
            value={presetLabel}
            onChange={(e) => setPresetLabel(e.target.value)}
          >
            <option value="">-- Select --</option>
            {labels.map((label, idx) => (
              <option key={idx} value={label}>{label}</option>
            ))}
          </select>
        </label>
      </div>

      <div className="buttons">
        <button onClick={handleStartPause}>
          {isRunning ? "Pause" : "Start"}
        </button>
        <button onClick={toggleMode}>
          Switch to {isUseful ? "Unuseful" : "Useful"} Time
        </button>
        <button onClick={handleStop}>Stop</button>
        <button onClick={exportCSV}>Export CSV</button>
      </div>
  

  <div className="timers">
        <p>Useful Time: {formatTime(usefulTime)}</p>
        <p>Unuseful Time: {formatTime(unusefulTime)}</p>
        <p className="total-time">Total Time: {formatTime(totalTime)}</p>

        {/* Combined stacked bar with labels */}
        <div className="stacked-bar">
          <div
            className="stack useful"
            style={{ width: `${usefulPercent}%` }}
          >
            {usefulPercent > 10 && (
              <span className="label">{usefulPercent.toFixed(0)}%</span>
            )}
          </div>
          <div
            className="stack unuseful"
            style={{ width: `${unusefulPercent}%` }}
          >
            {unusefulPercent > 10 && (
              <span className="label">{unusefulPercent.toFixed(0)}%</span>
            )}
          </div>
        </div>
      </div>
     

      {/* History log with filter */}
      <div className="history">
        <h2>Session History</h2>
        <label>
          Filter by Label:{" "}
          <select
            value={filterLabel}
            onChange={(e) => setFilterLabel(e.target.value)}
          >
            <option value="">All</option>
            {labels.map((label, idx) => (
              <option key={idx} value={label}>{label}</option>
            ))}
          </select>
        </label>

        {filteredHistory.length === 0 ? (
          <p>No sessions match this filter.</p>
        ) : (
          <ul>
            {filteredHistory.map((session, index) => (
              <li key={index}>
                <strong>{session.date}</strong> — 
                <span className={getLabelClass(session.label)}>
                  {session.label}
                </span> — Useful: {formatTime(session.useful)}, Unuseful:{" "}
                {formatTime(session.unuseful)}, Total:{" "}
                {formatTime(session.total)}
              </li>
            ))}
          </ul>
        )}
      </div>

      {/* Summary section */}
      <div className="summary">
        <h2>Overall Summary</h2>
        {history.length === 0 ? (
          <p>No data yet.</p>
        ) : (
          <div className="summary-stats">
            <p>Total Useful Time: {formatTime(totalUsefulAll)}</p>
            <p>Total Unuseful Time: {formatTime(totalUnusefulAll)}</p>
            <p>Grand Total Time: {formatTime(grandTotalAll)}</p>
            <p>Average Useful per Session: {formatTime(Math.round(avgUseful))}</p>
            <p>Average Unuseful per Session: {formatTime(Math.round(avgUnuseful))}</p>
            <p>Average Total per Session: {formatTime(Math.round(avgTotal))}</p>
          </div>
        )}
      </div>
      <div><br/><br/></div>
 <div>
        <section className="about-section">
        <p>
          Record the time on use and unuseful matters on different categories like exercise, job, leisure etc.,
        </p>
      </section>
      </div>
<div>
         <footer className="home-footer">
        <div className="footer-banner1">
          Thank you for choosing JAL Market to simplify your invoicing smooth and hassle-free! 🛒
        </div>
        <div>
          <img className="image-ban" src="./Images/jalm.png" alt="Just A Little Market" width="50" height="50" />
          
        </div>
        <p>© 2025 JALM  • Easy Invoice. &nbsp; &nbsp;   <Link to="/PrivacyPolicy" >Privacy Policy</Link>
          </p>
          
      </footer>
      </div>
     

    </div>
  );
}

export default RecordTime;


